import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from '../axios';
import '../Functions/manage_orders.css';
import { set } from 'rsuite/esm/internals/utils/date';

const AddNewCommercialForm = ({commercial_id}) => {
    const today = new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Dhaka' });

    const [formData, setFormData] = useState({
        com_date: today,
        invoice_no: '',
        duration: '',
        acceptance_terms: 'Acceptance',
        party_name: '',
        alt_party_name: '',
        alt_party_address: '',
        extra_parties: [],
        com_type: 'General',
        party_bank_id: '',
        alt_pi_no: '',
        lc_no: '',
        lc_date: today,
        amendment_info: '',
        amendment_date: '',
        contract_no: '',
        contract_date: today,
        netweight: '',
        grossweight: '',
        bundle: '',
        others_info: '',
        expiry_date: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSaveCommercial = () => {
        // console.log(formData);
        // console.log(selectedPIIds);
        const payload = {
            commercial_info: commercialPayload(),
            selectedPIIds: visibleSelectedPIIds()
        }

        axios.post(`${window.backendUrl}/add_new_commercial`, payload)
            .then(response => {
                setSelectedPIIds([]);
                setFormData({
                    com_date: today,
                    invoice_no: '',
                    duration: '',
                    acceptance_terms: 'Acceptance',
                    party_name: '',
                    alt_party_name: '',
                    alt_party_address: '',
                    extra_parties: [],
                    com_type: 'General',
                    party_bank_id: '',
                    alt_pi_no: '',
                    lc_no: '',
                    lc_date: today,
                    amendment_info: '',
                    amendment_date: '',
                    contract_no: '',
                    contract_date: today,
                    netweight: '',
                    grossweight: '',
                    bundle: '',
                    others_info: '',
                    expiry_date: '',
                })     
                window.location.reload()
            })
            .catch(error => {
                console.error('There was an error saving the data!', error);
            }
        );
    // Handle form submission
    };

    const [party_bank_options, set_party_bank_options]=useState([]);
    const [party_options, set_party_options]=useState([]);

    useEffect(() => {
        fetch_dropdown_options();
    }, []); 

    // 2. AddNewCommercialForm.jsx: Update fetch_dropdown_options to use the new API
    const fetch_dropdown_options = async () => {
        try {
            const response1 = await axios.get(`${window.backendUrl}/get_all_parties`);
            const response2 = await axios.get(`${window.backendUrl}/get_all_party_banks_with_address`);

            const options1 = response1.data.data.map((party) => party['PartyName']);
            const options2 = response2.data.data.map((party_bank) => {
                const name = party_bank['Name'] || '';
                const address = party_bank['Address'] || '';
                
                const shortName = name.split(' ').slice(0, 2).join(' ');
                
                let shortAddress = address;
                if (address.length > 25) {
                    const truncated = address.substring(0, 25);
                    const lastSpaceIndex = truncated.lastIndexOf(' ');
                    shortAddress = lastSpaceIndex > 0 ? truncated.substring(0, lastSpaceIndex) + '...' : truncated + '...';
                }

                return {
                    value: party_bank['PartyBankID'], // <--- THIS NOW HOLDS THE ID
                    label: `${shortName} - ${shortAddress}`
                };
            });

            set_party_options(options1);
            set_party_bank_options(options2);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const [selectedPIIds, setSelectedPIIds] = useState([]);
    const [PINumbers,setPINumbers]=useState([]);
    // Sister concerns of the party whose jobs this LC can also carry. Their open PIs are kept apart
    // from PINumbers (the main party's list), one list per party, so adding or removing a party never
    // disturbs the main party's list or its ticked PIs.
    const extraParties = (formData.extra_parties || []).filter((p) => p && p !== formData.party_name);
    const [extraPINumbers, setExtraPINumbers] = useState({}); // { partyName: [{ pi_no, pi_id }] }

    // Main party's PIs first, then each extra party's (skipping any PI already listed).
    const allPINumbers = [];
    [PINumbers, ...extraParties.map((p) => extraPINumbers[p] || [])].forEach((list) => {
        list.forEach((pi) => {
            if (!allPINumbers.some((x) => String(x.pi_id) === String(pi.pi_id))) allPINumbers.push(pi);
        });
    });

    // Only PIs that are actually on screen may be saved, so a PI ticked for a party that has since
    // been removed can never be attached silently.
    const visibleSelectedPIIds = () =>
        selectedPIIds.filter((id) => allPINumbers.some((pi) => String(pi.pi_id) === String(id)));

    useEffect(() => {
        const missing = extraParties.filter((p) => !extraPINumbers[p]);
        if (!missing.length) return;
        let cancelled = false;
        missing.forEach((party) => {
            axios.get(`${window.backendUrl}/get_all_pi_nos/${encodeURIComponent(party)}`)
                .then((response) => {
                    if (cancelled) return;
                    const list = response.data.data.map((pi) => ({
                        pi_no: `PI/${pi['JobNumber']} ($${pi['TotalPrice']})`,
                        pi_id: pi['PiId']
                    }));
                    setExtraPINumbers((prev) => ({ ...prev, [party]: list }));
                }).catch((error) => {
                    console.error('Error fetching PIs of', party, error);
                });
        });
        return () => { cancelled = true; };
    }, [extraParties.join('|')]); // eslint-disable-line react-hooks/exhaustive-deps

    const addExtraParty = (party) => {
        if (!party || party === formData.party_name || extraParties.includes(party)) return;
        setFormData((prev) => ({ ...prev, extra_parties: [...(prev.extra_parties || []), party] }));
    };

    const removeExtraParty = (party) => {
        setFormData((prev) => ({
            ...prev,
            extra_parties: (prev.extra_parties || []).filter((p) => p !== party),
            // The party shown on the documents can only be one of the parties still on this LC.
            alt_party_name: prev.alt_party_name === party ? '' : prev.alt_party_name,
        }));
    };

    // Party printed on the documents: empty alt_party_name = the main party.
    const docParty = formData.alt_party_name && (formData.alt_party_name === formData.party_name || extraParties.includes(formData.alt_party_name))
        ? formData.alt_party_name : formData.party_name;

    const setDocParty = (party) => {
        setFormData((prev) => ({
            ...prev,
            alt_party_name: party === prev.party_name ? '' : party,
            alt_party_address: party === prev.alt_party_name ? prev.alt_party_address : '',
        }));
    };

    // What is saved: the extra parties on screen, and the printed party only if it is still one of them.
    const commercialPayload = () => ({
        ...formData,
        extra_parties: extraParties,
        alt_party_name: docParty === formData.party_name ? '' : docParty,
    });

    useEffect(() => {
        if (formData.party_name === '') {
            setPINumbers([]);
            return;
        }
        if (formData.original_party_name !== formData.party_name) {
            axios.get(`${window.backendUrl}/get_all_pi_nos/${formData.party_name}`)
                .then((response) => {
                    const options = response.data.data.map((pi) => ({
                        pi_no: `PI/${pi['JobNumber']} ($${pi['TotalPrice']})`,
                        pi_id: pi['PiId']
                    }));
                    setPINumbers(options);
                    setSelectedPIIds([])
                }).catch((error) => {
                    console.error('Error fetching data:', error);
                });
        }

        if (formData.original_party_name == formData.party_name) {

            axios.get(`${window.backendUrl}/get_commercial_info/${commercial_id}`)
                .then((response) => {
                    setSelectedPIIds(response.data.data.selectedPIIds);
                    setPINumbers(response.data.data.PINumbers);
                })
                .catch((error) => {
                    console.error('Error fetching commercial data:', error);
                });
        }
           
    }, [formData.party_name]);


    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        setSelectedPIIds(prevValues => {
          if (checked) {
            // Add value to selectedValues if checkbox is checked
            return [...prevValues, value];
          } else {
            // Remove value from selectedValues if checkbox is unchecked
            return prevValues.filter(item => item !== value);
          }
        });
    };

    useEffect(() => {
        if (commercial_id) {
            axios.get(`${window.backendUrl}/get_commercial_info/${commercial_id}`)
                .then((response) => {
                    // console.log(response.data.data);
                    setFormData(response.data.data.commercial_info);
                    setSelectedPIIds(response.data.data.selectedPIIds);
                    setPINumbers(response.data.data.PINumbers);
                    // console.log(PINumbers);
                })
                .catch((error) => {
                    console.error('Error fetching commercial data:', error);
                });
        }
    }, [commercial_id]); 

    const handleChangeCommercial = () => {
        const payload = {
            commercial_id: commercial_id,
            commercial_info: commercialPayload(),
            selectedPIIds: visibleSelectedPIIds()
        }

        axios.post(`${window.backendUrl}/update_commercial`, payload)
            .then(response => {
                setSelectedPIIds([]);
                setFormData({
                    com_date: today,
                    invoice_no: '',
                    duration: '',
                    acceptance_terms: 'Acceptance',
                    party_name: '',
                    alt_party_name: '',
                    alt_party_address: '',
                    extra_parties: [],
                    com_type: 'General',
                    party_bank_id: '',
                    alt_pi_no: '',
                    lc_no: '',
                    lc_date: today,
                    amendment_info: '',
                    amendment_date: '',
                    contract_no: '',
                    contract_date: today,
                    netweight: '',
                    grossweight: '',
                    bundle: '',
                    others_info: '',
                    expiry_date: '',
                })       
                window.location.reload()
            })
            .catch(error => {
                console.error('There was an error saving the data!', error);
            }
        );
    }
    return (
    <Container style={{ backgroundColor: 'rgba(0,0,0,0.08)', padding: '10px 25px', borderRadius: '5px' }}>
        <h5 className='mt-1'>Add New Commercial</h5>
        <Form style={{fontSize:'15px', margin:'20px 0 10px 0'}}>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Comm. Date *:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            <Form.Control
                type="date"
                name="com_date"
                value={formData.com_date}
                onChange={handleChange}
            />
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Invoice No. *:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            <Form.Control
                type="text"
                name="invoice_no"
                value={formData.invoice_no}
                onChange={handleChange}
            />
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Duration *:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            <Form.Control
                type="text"
                name="duration"
                value={formData.duration}
                onChange={handleChange}
                placeholder="Duration"
                
            />
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Acceptance Terms *:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
                <Form.Select name="acceptance_terms" value={formData.acceptance_terms} onChange={handleChange}>
                    <option value="Acceptance">Acceptance</option>
                    <option value="Delivery">Delivery</option>
                </Form.Select>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Party Name *:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
                <Form.Select name="party_name" value={formData.party_name} onChange={handleChange}>
                    <option value="">Select Party Name</option>
                    {party_options.map((party, index) => (
                        <option key={index} value={party}>
                        {party}
                        </option>
                    ))}
                </Form.Select>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Other Parties (sister concerns):</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
                {extraParties.map((party) => (
                    <div key={party} className="d-flex align-items-center justify-content-between mb-1"
                        style={{ background: '#fff', border: '1px solid #ced4da', borderRadius: '4px', padding: '4px 8px' }}>
                        <span>{party}</span>
                        <Button variant="link" size="sm" className="text-danger p-0 ms-2" title="Remove this party"
                            onClick={() => removeExtraParty(party)}>✕</Button>
                    </div>
                ))}
                <Form.Select value="" onChange={(e) => addExtraParty(e.target.value)} disabled={!formData.party_name}>
                    <option value="">{formData.party_name ? '+ Add party' : 'Select the party first'}</option>
                    {party_options
                        .filter((party) => party !== formData.party_name && !extraParties.includes(party))
                        .map((party, index) => (
                            <option key={index} value={party}>
                            {party}
                            </option>
                        ))}
                </Form.Select>
            </Col>
        </Row>
        {formData.party_name && extraParties.length > 0 && (
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Show on documents:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
                {[formData.party_name, ...extraParties].map((party) => (
                    <Form.Check key={party} type="radio" id={`doc-party-${party}`} name="doc_party"
                        label={party === formData.party_name ? `${party} (main)` : party}
                        checked={docParty === party} onChange={() => setDocParty(party)} />
                ))}
            </Col>
        </Row>
        )}
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Comm. Type *:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
                <Form.Select name="com_type" value={formData.com_type} onChange={handleChange}>
                    <option value="General">General</option>
                    <option value="Group PI">Group PI</option>
                    <option value="Master PI">Master PI</option>
                </Form.Select>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Party Bank *:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
                <Form.Select name="party_bank_id" value={formData.party_bank_id} onChange={handleChange}>
                    <option value="">Select Party Bank Name</option>
                    {party_bank_options.map((party_bank, index) => (
                        <option key={index} value={party_bank.value}>
                        {party_bank.label}
                        </option>
                    ))}
                </Form.Select>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Alt. PI Number:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            <Form.Control
                type="text"
                name="alt_pi_no"
                value={formData.alt_pi_no}
                onChange={handleChange}
                placeholder="Alternative PI Number"
            />
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>PI Number *:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            {(allPINumbers.length > 0) ? (
                allPINumbers.map((pi, index) => (
                    <div className='d-flex' key={pi.pi_id}>
                        <input type="checkbox" value={pi.pi_id} onChange={handleCheckboxChange} checked={selectedPIIds.includes(pi.pi_id.toString())}  style={{marginRight:'10px'}} />
                        <p><strong>{pi.pi_no}</strong></p>
                    </div>
                ))):(
                 <p>No PI</p>
                )}
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>LC No. *:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            <Form.Control
                type="text"
                name="lc_no"
                value={formData.lc_no}
                onChange={handleChange}
                placeholder="LC No."
                
            />
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>LC Date *:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            <Form.Control
                type="date"
                name="lc_date"
                value={formData.lc_date}
                onChange={handleChange}
                
            />
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Amendment Info.:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            <Form.Control
                type="text"
                name="amendment_info"
                value={formData.amendment_info}
                onChange={handleChange}
                placeholder="Amendment Info"
                
            />
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Amendment Date:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            <Form.Control
                type="date"
                name="amendment_date"
                value={formData.amendment_date || ''}
                onChange={handleChange}
            />
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Export LC/SC No. :</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            <Form.Control
                type="text"
                name="contract_no"
                value={formData.contract_no}
                onChange={handleChange}
                placeholder="Export LC/SC No."
                
            />
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Export LC/SC Date :</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            <Form.Control
                type="date"
                name="contract_date"
                value={formData.contract_date}
                onChange={handleChange}
                
            />
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Net weight:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            <Form.Control
                type="text"
                name="netweight"
                value={formData.netweight}
                onChange={handleChange}
                placeholder="Net weight"
                
            />
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Gross weight:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            <Form.Control
                type="text"
                name="grossweight"
                value={formData.grossweight}
                onChange={handleChange}
                placeholder="Gross weight"
                
            />
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Bundle:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            <Form.Control
                type="number"
                name="bundle"
                value={formData.bundle}
                onChange={handleChange}
                placeholder="Bundle"
            />
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Others Info :</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            <Form.Control
                as='textarea'
                name="others_info"
                value={formData.others_info}
                onChange={handleChange}
                placeholder="Others Info"
                
            />
            </Col>
        </Row>
        <Row className="mb-3">
            <Col sm={4}>
            <Form.Label><strong>Expiry Date *:</strong></Form.Label>
            </Col>
            <Col style={{width:'300px'}}>
            <Form.Control
                type="date"
                name="expiry_date"
                value={formData.expiry_date}
                onChange={handleChange}
                
            />
            </Col>
        </Row>
        <Row className='d-flex justify-content-end'>
            <Col sm={8}>
                {(commercial_id == null) ?
                
                (<Button variant="primary" onClick={handleSaveCommercial}>
                    Save Commercial
                </Button>)
                :(<Button variant="primary" onClick={handleChangeCommercial}>
                    Change Commercial
                </Button>)
            }   
            </Col>
        </Row>
        </Form>
    </Container>
    );
};

export default AddNewCommercialForm;